import React from "react";
import { Image, OverlayTrigger, Popover } from "react-bootstrap";

/////////////////////////////////
//////  Icon -> pasarle la imagen
//////  filter -> clase de CSS https://codepen.io/sosuke/pen/Pjoqqp creamos los filtros para pasar a este componente el filtro a aplicar
//////  size -> entero que corresponde al tamaño del icono a pintar
//////  position -> string que indica la posición en la que queremos que aparezca el mensaje del pop-over
//////  title -> title del popover
//////  content -> contenido del popover
/////////////////////////////////

const TooltipIcon = ({ Icon, filter = "filter-blue-stj", size = "15px", position, title, content, ...props }) => {
  return (
    <div {...props}>
      <OverlayTrigger
        //trigger="hover"
        placement={position}
        overlay={
          <Popover>
            {title && (
              <Popover.Title as="h3">
                <span>{title}</span>
              </Popover.Title>
            )}
            <Popover.Content>{content}</Popover.Content>
          </Popover>
        }
      >
        <Image className={filter} style={{ cursor: "pointer" }} width={size} src={Icon ? Icon : `/icons/info.svg`} />
      </OverlayTrigger>
    </div>
  );
};

export default TooltipIcon;
